import React from 'react';
import { Link } from "react-router-dom";
import CreateIcon from "@material-ui/icons/Create";
import BallotIcon from "@material-ui/icons/Ballot";
import VisibilityIcon from "@material-ui/icons/Visibility";
import NoteIcon from "@material-ui/icons/Note";
import AccountTreeIcon from "@material-ui/icons/AccountTree";
import FormatListBulletedIcon from "@material-ui/icons/FormatListBulleted";
import TuneIcon from "@material-ui/icons/Tune";
import HomeWorkIcon from "@material-ui/icons/HomeWork";
import LiveHelpIcon from "@material-ui/icons/LiveHelp";
import DescriptionIcon from "@material-ui/icons/Description";
import DynamicFeedIcon from "@material-ui/icons/DynamicFeed";
import TableChartIcon from "@material-ui/icons/TableChart";
import VerticalSplitIcon from "@material-ui/icons/VerticalSplit";
import ListAltIcon from "@material-ui/icons/ListAlt";
import LocalLibraryIcon from "@material-ui/icons/LocalLibrary";
import {
  Assessment,
  CloudUpload,
  DesktopMac,
  Domain,
  DomainDisabled,
  LocationOn,
  People,
  Receipt,
} from "@material-ui/icons";
import ListIcon from "@material-ui/icons/List";
import { Toolbar } from '@material-ui/core';

// Map tile IDs to Material-UI icons
const iconMap = {
  1: CreateIcon,
  2: BallotIcon,
  3: VisibilityIcon,
  4: Receipt,
  5: HomeWorkIcon,
  6: NoteIcon,
  7: AccountTreeIcon,
  8: FormatListBulletedIcon,
  9: TuneIcon,
  10: TuneIcon,
  11: LocalLibraryIcon,
  12: LocationOn,
  13: ListIcon,
  14: Assessment,
  15: Assessment,
  16: Assessment,
  17: CloudUpload,
  18: DesktopMac,
  19: FormatListBulletedIcon,
  20: LiveHelpIcon,
  21: DescriptionIcon,
  22: ListAltIcon,
  23: DynamicFeedIcon,
  24: VerticalSplitIcon,
  25: TableChartIcon,
  26: ListAltIcon,
  27: ListAltIcon,
  31: People,
  32: DomainDisabled,
  33: Domain,
  34: ListAltIcon,
  35: ListAltIcon,
  36: VerticalSplitIcon,
  37: Toolbar,
};

const TileRenderer = ({ tile }) => {
  const IconComponent = iconMap[tile.id] || CreateIcon;

  // Use displayText if available, otherwise smart split
  const getDisplayText = () => {
    if (tile.displayText) {
      return tile.displayText;
    }

    // Fallback: Split by common separators
    const parts = tile.name.split(/(?:&|\band\b)/i);

    if (parts.length > 1) {
      return {
        first: parts[0].trim(),
        second: parts.slice(1).join('&').trim()
      };
    }

    // Otherwise split at last word
    const words = tile.name.split(' ');
    if (words.length === 1) {
      return { first: '', second: tile.name };
    }

    return {
      first: words.slice(0, -1).join(' '),
      second: words.slice(-1)[0]
    };
  };

  const { first, second } = getDisplayText();

  // Render external link
  if (tile.isExternal) {
    return (
      <div>
        <a
          href={tile.route}
          rel="noopener noreferrer"
          className="panel"
          style={{ fontSize: "3rem", color: tile.color }}
        >
          <IconComponent style={{ fontSize: "3rem", color: tile.color }} />
        </a>
        <p className="card-btn-para">
          {first && `${first} `}
          <span className="card-btn-span">{second}</span>
        </p>
      </div>
    );
  }

  // Render internal link
  return (
    <div>
      <Link to={tile.route} className="panel">
        <IconComponent style={{ fontSize: "3rem", color: tile.color }} />
      </Link>
      <p className="card-btn-para">
        {first && `${first} `}
        <span className="card-btn-span">{second}</span>
      </p>
    </div>
  );
};

export default TileRenderer;
